import React from 'react';
import P from 'prop-types';
import './styles.css';
import { Obrigatorios } from '../Obrigatorios';
import { Adicionais } from '../Adicionais';

export const TemplateSelector = ({ data, action, somar, subtrair, handleQtdeSelecionada }) => {
  switch (data.TipoMontagem) {
    case 'OBRIGATORIO':
    case 'COMBO':
      if (data.QtdeObrigatoria === 1) {
        return <Obrigatorios key={data.Produto.descricao} data={data} action={action} />;
      } else {
        return (
          <Adicionais
            key={data.Produto.descricao}
            data={data}
            somar={somar}
            subtrair={subtrair}
            handleQtdeSelecionada={handleQtdeSelecionada}
          />
        );
      }

    case 'PIZZA':
    case 'ADICIONAL':
      return (
        <Adicionais
          key={data.Produto.descricao}
          data={data}
          somar={somar}
          subtrair={subtrair}
          handleQtdeSelecionada={handleQtdeSelecionada}
        />
      );

    default:
      return <span key={data.Produto.descricao}></span>;
  }
};

TemplateSelector.propTypes = {
  data: P.object,
  action: P.func,
  somar: P.func,
  subtrair: P.func,
  handleQtdeSelecionada: P.func,
};
